import * as React from 'react'
import { formatDate } from 'src/libs/formatDates'

import { useDeposit } from './hooks'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CInputGroup,
  CInputGroupText,
  CNav,
  CNavItem,
  CNavLink,
  CRow,
  CSpinner,
  CTabContent,
  CTabPane,
} from '@coreui/react-pro'
import {
  setDeposit,
  submitStatus,
  submitEditDeposit,
  getInstalmentsEvent,
} from './model'
import {
  Button,
  Card,
  Col,
  Divider,
  Flex,
  Popconfirm,
  Row,
  Space,
  Tabs,
  Tag,
} from 'antd'
import {
  buttonColorTransactionRequestStatus,
  colorTransactionRequestStatus,
  humanDepositRejectionReason,
  humanTransactionRequestStatus,
  humanTransactionRequestStatusButton,
  statusDepositFlow,
  transactionRequestDestinationType,
  transactionRequestStatus,
} from '../../const'
import { CheckCircleOutlined, CloseSquareOutlined } from '@ant-design/icons'
import { RejectModal } from '../atoms/rejectModal'
import { RollbackModal } from '../atoms/rollbackModal'
import { path, role } from '../../../../libs'
import { useState } from 'react'
import { TransactionList } from '../../../../views/widgets/transactionList'
import { ActionHistory } from '../../widgets/ActionHistory'
import { Typography } from 'antd'
import { useStore } from 'effector-react'
import { $userRole } from '../../../../features/user'
import { MoneyHistoryList } from '../../../../views/widgets/moneyHistoryList'
import { GroupedClientPursesList } from '../../../../views/widgets/groupedClientPurses'
import { processingProviderName } from '../../../../libs/processingProvider'
import { ChangeAmountsModal } from '../atoms/changeAmountsModal/component'
import { Guard } from '../../../../features/session/guard'
import { TransactionHelpModal } from '../../widgets/TransactionHelpModal/component'
import {
  getRolesByGuardRules,
  GUARD_RULES,
} from '../../../../features/session/constants'
import { AdjustmentDepositModal } from 'src/pages/billing/deposits/atoms/adjustmentDepositModal'
import { ClientCard } from '../atoms/ClientCard'
import { DepositDetailTab } from '../atoms/DepositDetailTab'
import { CommentFormAntd } from '../../../../views/widgets/commentForm'
import { CommentList } from '../../../../views/widgets/commentList'

export const DepositEditDetail = () => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isOpenAdjustmentDepositModal, setIOpenAdjustmentDepositModal] =
    useState(false)

  const {
    deposit,
    amountVisited,
    loading,
    actionLoading,
    clientPurses,
    error,
    success,
    instalmentItem,
    instalmentLoading,
  } = useDeposit()

  const userRole = useStore($userRole)
  const handleChange = (event: {
    currentTarget: { name: any; type: string; checked?: any; value: any }
  }) => {
    switch (event.currentTarget.name) {
      case 'initialAmount':
        amountVisited.amount.initialAmountVisited =
          amountVisited.amount.initialAmount != event.currentTarget.value
        break
      case 'initialCurrency':
        amountVisited.amount.initialCurrencyVisited =
          amountVisited.amount.initialCurrency != event.currentTarget.value
        break
      case 'clientAmount':
        amountVisited.amount.clientAmountVisited =
          amountVisited.amount.clientAmount != event.currentTarget.value
        break
      case 'clientCurrency':
        amountVisited.amount.clientCurrencyVisited =
          amountVisited.amount.clientCurrency != event.currentTarget.value
        break
      case 'companyAmount':
        amountVisited.amount.companyAmountVisited =
          amountVisited.amount.companyAmount != event.currentTarget.value
        break
      case 'companyCurrency':
        amountVisited.amount.companyCurrencyVisited =
          amountVisited.amount.companyCurrency != event.currentTarget.value
        break
    }

    const value =
      event.currentTarget.type === 'checkbox'
        ? event.currentTarget.checked
        : event.currentTarget.value

    setDeposit({
      ...deposit,
      [event.currentTarget.name]: value,
    })
  }

  const [activeTab, setActiveTab] = useState('detail')
  const [activeClientTab, setActiveClientTab] = useState(1)

  const canEditGateway = getRolesByGuardRules('edit_gateway').some((r) =>
    userRole?.includes(r),
  )

  const getSource = () => {
    const isWallet =
      deposit.destinationType === transactionRequestDestinationType.wallet() ||
      deposit.destinationType === 'wallet'
    const isExchanger =
      // @ts-ignore — exchanger.id is string, destinationId is number
      (deposit.client?.exchanger?.id == deposit.destinationId ||
        deposit.gateway?.exchanger?.id) &&
      deposit.destinationType === 'exchanger'

    if (isExchanger) {
      return 'Exchanger'
    }
    if (isWallet) {
      const wallet = deposit.client.wallets.find(
        (wallet) => wallet.walletId === deposit.destinationId,
      )
      return `Wallet ${wallet?.currency ?? ''}`.trim()
    }
    const account = deposit.client.accounts.find(
      (account) => account.accountId === deposit.destinationId,
    )
    return account
      ? `${account.accountPlatform} ${account.mtLogin}`
      : 'Not found'
  }

  const handleCopyForDealers = () => {
    const currentOriginHost = window.location.origin

    const textForCopy = `
RDC Link: https://rdc.hwmt.link/module/query/info-by-client?id=${
      deposit.client.clientId
    }
User ID: ${deposit.client.clientId}
Client Link: ${currentOriginHost}${path.clients.details(
      deposit.client.clientId,
    )}
Deposit Link: ${currentOriginHost}${path.billing.deposit.edit(
      deposit.transactionId,
    )}
Full name: ${deposit.client.fullName}
E-mail: ${deposit.client.email}
Client amount: ${deposit.clientAmount} ${deposit.clientCurrency}
Initial amount: ${deposit.initialAmount} ${deposit.initialCurrency}
Source: ${getSource()}
    `.trim()

    navigator.clipboard.writeText(
      textForCopy.replace(/^\s+|\s+(?=[\n\r])/gm, ''),
    )
  }

  const canViewAdjustDeposit = () => {
    return (
      ![
        transactionRequestStatus.accepted(),
        transactionRequestStatus.pendingDestination(),
      ].includes(deposit.status) &&
      deposit.processingProvider.toLowerCase() === 'help2pay'
    )
  }

  React.useEffect(() => {
    if (
      !loading &&
      deposit.transactionType == 'TRANSACTION_REQUEST_TYPE_NOVA_SALE'
    ) {
      getInstalmentsEvent()
    }
  }, [deposit.transactionType])

  if (loading && !deposit.transactionId) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 400,
        }}
      >
        <CSpinner color="primary" />
      </div>
    )
  }

  return (
    <div>
      <Flex
        justify="flex-end"
        align="center"
        gap={8}
        style={{ marginBottom: 12 }}
      >
        <Button
          size="large"
          target="_blank"
          color="orange"
          variant="solid"
          href={
            'https://rdc.hwmt.link/module/query/info-by-client?id=' +
            deposit.client.clientId
          }
          style={{ textDecoration: 'none' }}
        >
          Open RDC
        </Button>
        <Button
          size="large"
          color="geekblue"
          variant="solid"
          onClick={handleCopyForDealers}
        >
          Copy for Dealers
        </Button>
        <Button
          size="large"
          color="geekblue"
          variant="solid"
          onClick={() => setIsOpenModal(true)}
        >
          Request technical help
        </Button>
      </Flex>
      <Row gutter={16}>
        <Col span={6}>
          <Card>
            <ClientCard deposit={deposit} />
            {deposit.clientId !== '' &&
              userRole &&
              !userRole.includes(role.clientSupport.supportAgent()) &&
              !userRole.includes(role.clientSupport.supportManager()) && (
                <>
                  <Divider />
                  <CommentFormAntd type="client" entityId={deposit.clientId} />
                  <div style={{ marginTop: 12 }}>
                    <CommentList
                      entityType="client"
                      entityId={deposit.clientId}
                      columns={1}
                    />
                  </div>
                </>
              )}
          </Card>
        </Col>
        <Col span={18}>
          <Card>
            <Flex
              justify="space-between"
              align="flex-start"
              wrap="wrap"
              gap={12}
            >
              <Space size="small" align="center" wrap>
                <Tag
                  color={deposit.product === 'headway' ? '#dbb454' : '#50f9ac'}
                  style={{ color: '#000', margin: 0 }}
                >
                  {deposit.product}
                </Tag>
                <Typography.Title level={5} style={{ margin: 0 }}>
                  deposit {deposit.transactionId}
                </Typography.Title>
                <Tag color={deposit.isAuto ? '#2eb85c' : '#321fdb'}>
                  {deposit.isAuto ? 'Auto' : 'Manual'}
                </Tag>
                <Tag
                  color={colorTransactionRequestStatus(deposit.status)}
                  title={deposit.status}
                >
                  {humanTransactionRequestStatus(deposit.status)}
                </Tag>
              </Space>
              <Flex vertical align="flex-end">
                {deposit.createdAt && (
                  <Typography.Text type="secondary">
                    Created{' '}
                    <Typography.Text strong style={{ fontSize: 18 }}>
                      {formatDate(deposit.createdAt)}
                    </Typography.Text>{' '}
                  </Typography.Text>
                )}
                {deposit.updatedAt && (
                  <Typography.Text
                    type={
                      deposit.updatedAt !== deposit.createdAt
                        ? 'warning'
                        : 'secondary'
                    }
                  >
                    Updated{' '}
                    <Typography.Text
                      strong
                      style={{ fontSize: 18 }}
                      type={
                        deposit.updatedAt !== deposit.createdAt
                          ? 'warning'
                          : undefined
                      }
                    >
                      {formatDate(deposit.updatedAt)}
                    </Typography.Text>{' '}
                  </Typography.Text>
                )}
              </Flex>
            </Flex>
            <Divider />
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={[
                {
                  key: 'detail',
                  label: 'Detail',
                  children: (
                    <DepositDetailTab
                      deposit={deposit}
                      loading={loading}
                      actionLoading={actionLoading}
                      error={error}
                      success={success}
                      clientPurses={clientPurses}
                      instalmentItem={instalmentItem}
                      instalmentLoading={instalmentLoading}
                      userRole={userRole ?? undefined}
                      setIsOpenAdjustmentDepositModal={
                        setIOpenAdjustmentDepositModal
                      }
                    />
                  ),
                },
                {
                  key: 'history',
                  label: 'History',
                  children: (
                    <>
                      <CCol xs={12}>
                        <CCard className="mb-4">
                          <CCardBody className="bg-dark">
                            {deposit?.clientId != '' && (
                              <TransactionList entityId={deposit.clientId} />
                            )}
                          </CCardBody>
                        </CCard>
                      </CCol>
                    </>
                  ),
                },
                {
                  key: 'money',
                  label: 'Money history',
                  children: (
                    <>
                      <CRow>
                        <CCol xs={12}>
                          <CCard className="mb-4">
                            <CCardHeader>
                              <strong>Money History</strong>
                            </CCardHeader>
                            <CCardBody>
                              {deposit?.clientId != '' && (
                                <MoneyHistoryList
                                  entityId={deposit.clientId}
                                  client={{
                                    name: deposit.client?.fullName,
                                    email: deposit.client?.email,
                                    country: deposit.client?.country,
                                  }}
                                />
                              )}
                            </CCardBody>
                          </CCard>
                        </CCol>
                      </CRow>
                    </>
                  ),
                },
                {
                  key: 'grouped',
                  label: 'Client grouped purses',
                  children:
                    deposit?.clientId != '' ? (
                      <GroupedClientPursesList entityId={deposit.clientId} />
                    ) : null,
                },
                {
                  key: 'action',
                  label: 'Action history',
                  children: (
                    <ActionHistory history={deposit.changeHistoryAll} />
                  ),
                },
              ]}
            />
          </Card>
        </Col>
      </Row>

      {/* ——— Legacy implementation (kept below during migration) ——— */}
      {/* <Divider />
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Edit deposit {deposit.transactionId}</strong>
        </CCardHeader>
        <CCardBody>
          <CNav variant="tabs" role="tablist">
            <CNavItem>
              <CNavLink
                data-tab="detail"
                href="#!"
                active={activeClientTab === 1}
                onClick={() => setActiveClientTab(1)}
              >
                Detail
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                data-tab="history"
                href="#!"
                active={activeClientTab === 2}
                onClick={() => setActiveClientTab(2)}
              >
                History
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                data-tab="moneyHistory"
                href="#!"
                active={activeClientTab === 3}
                onClick={() => setActiveClientTab(3)}
              >
                Money history
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                data-tab="actionHistory"
                href="#!"
                active={activeClientTab === 4}
                onClick={() => setActiveClientTab(4)}
              >
                Action history
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent className="pt-3">
            <CTabPane
              data-tab="detail"
              role="tabpanel"
              aria-labelledby="contact-tab"
              visible={activeClientTab === 1}
            >
              <Tag
                color={colorTransactionRequestStatus(deposit.status)}
                title={deposit.status}
              >
                {humanTransactionRequestStatus(deposit.status)}
              </Tag>

              <Guard permission="edit_tranasaction_status">
                <>
                  {userRole != undefined &&
                    userRole.indexOf(role.clientSupport.supportAgent()) == -1 &&
                    userRole.indexOf(role.clientSupport.supportManager()) ==
                      -1 &&
                    statusDepositFlow(deposit.status)?.map((item) => {
                      if (
                        item == transactionRequestStatus.rollback() &&
                        deposit.processingProvider !==
                          processingProviderName.mt5()
                      ) {
                        return (
                          <RollbackModal className="ms-2" request={deposit} />
                        )
                      } else if (item == transactionRequestStatus.rejected()) {
                        return (
                          <RejectModal className="ms-2" request={deposit} />
                        )
                      } else if (
                        item == transactionRequestStatus.rollback() &&
                        deposit.processingProvider ==
                          processingProviderName.mt5()
                      ) {
                        return <></>
                      } else if (
                        deposit.product !== 'nova' ||
                        (deposit.product == 'nova' &&
                          item == transactionRequestStatus.accepted() &&
                          (deposit.status ==
                            transactionRequestStatus.pendingManager() ||
                            deposit.status == transactionRequestStatus.ps()))
                      ) {
                        return (
                          <Button
                            style={{
                              color:
                                buttonColorTransactionRequestStatus(item).text,
                              backgroundColor:
                                buttonColorTransactionRequestStatus(item)
                                  .background,
                            }}
                            className="ms-2"
                            disabled={actionLoading}
                            loading={actionLoading}
                            onClick={() => {
                              submitStatus({
                                transactionId: deposit.transactionId,
                                status: item,
                              })
                            }}
                          >
                            {humanTransactionRequestStatusButton(
                              item,
                              deposit.processingProvider,
                            )}
                          </Button>
                        )
                      }
                    })}
                </>
              </Guard>
              <Guard
                permission={GUARD_RULES.CREATE_HELP2PAY_ADJUSTMENT_DEPOSIT}
              >
                {canViewAdjustDeposit() && (
                  <Popconfirm
                    title="Confirm adjustment creation"
                    description="Are you sure you want to create an adjustment deposit?"
                    okText="Yes"
                    onConfirm={() => setIOpenAdjustmentDepositModal(true)}
                    cancelText="No"
                  >
                    <Button className="ms-2" type="primary">
                      Create Adjustment Deposit
                    </Button>
                  </Popconfirm>
                )}
              </Guard>
              <Divider />
              <CRow>
                <CCol sm={12}>
                  <strong>Product: </strong>
                  <Tag
                    color={deposit.product == 'headway' ? '#dbb454' : '#50f9ac'}
                    style={{ color: '#000' }}
                  >
                    {deposit.product}
                  </Tag>
                  <div className={'mt-3'}>
                    {!instalmentLoading &&
                      instalmentItem.status != '' &&
                      deposit.transactionType ==
                        'TRANSACTION_REQUEST_TYPE_NOVA_SALE' && (
                        <>
                          <p>
                            Instalment ID -{' '}
                            <a
                              target="_blank"
                              href={path.nova.instalments.entry(
                                instalmentItem?.installment?.id,
                              )}
                            >
                              {instalmentItem?.installment?.id}
                            </a>
                          </p>
                          <p>Instalment payment {instalmentItem?.planStage}</p>
                        </>
                      )}
                  </div>
                </CCol>
                <Divider />
                <CCol>
                  {deposit.externalPaymentTransaction?.extraData &&
                    deposit.processingProvider == 'korapay' && (
                      <>
                        <h5>Transaction Details</h5>
                        {Object.entries(
                          JSON.parse(
                            deposit.externalPaymentTransaction?.extraData,
                          ),
                        ).map(([key, value]) => {
                          return <p key={key}>{`${key}: ${value}`}</p>
                        })}
                        <Divider />
                      </>
                    )}
                  {deposit.processingProvider == 'spayz' &&
                    deposit.clientPurse && (
                      <>
                        <h6>Transaction Details</h6>
                        <p key={deposit.clientPurse?.bankName}>
                          Bank name: {deposit.clientPurse?.bankName}
                        </p>
                        <p key={deposit.clientPurse?.clientName}>
                          Client name: {deposit.clientPurse?.clientName}
                        </p>
                        <Divider />
                      </>
                    )}
                  rejectReason:{' '}
                  {deposit.rejectReason?.length > 0 &&
                    humanDepositRejectionReason(deposit.rejectReason)}
                  {deposit.gateway?.internalName && (
                    <p>
                      Gateway:{' '}
                      {deposit.gateway.gatewayId &&
                        (canEditGateway ? (
                          <a
                            href={path.billing.gateway.edit(
                              deposit.gateway.gatewayId.toString(),
                            )}
                            target="_blank"
                          >
                            {deposit.gateway.gatewayId}
                          </a>
                        ) : (
                          <span>{deposit.gateway.gatewayId}</span>
                        ))}{' '}
                      {deposit.gateway.internalName}
                    </p>
                  )}
                  {deposit.rejectReason?.length > 0 && (
                    <p>rejectReason: {deposit.rejectReason}</p>
                  )}
                  {deposit.psComment?.length > 0 && (
                    <p>psComment: {deposit.psComment}</p>
                  )}
                  {deposit.managerComment?.length > 0 && (
                    <p>managerComment: {deposit.managerComment}</p>
                  )}
                  {deposit.internalComment?.length > 0 && (
                    <p>internalComment: {deposit.internalComment}</p>
                  )}
                </CCol>
              </CRow>
              <Divider />
              <CRow>
                <CCol sm={3} className={'d-flex align-items-center gap-2'}>
                  manager: {deposit.changeHistory?.user?.email}
                </CCol>
              </CRow>
              {deposit.confirmedByManagerAt && (
                <CRow>
                  <CCol sm={3} className={'d-flex align-items-center gap-2'}>
                    Data of confirmed by manager: {deposit.confirmedByManagerAt}
                  </CCol>
                </CRow>
              )}
              {deposit.confirmedByVendorAt && (
                <CRow>
                  <CCol sm={3} className={'d-flex align-items-center gap-2'}>
                    Data of confirmed by vendor: {deposit.confirmedByVendorAt}
                  </CCol>
                </CRow>
              )}
              <Divider />
              <CRow>
                <CCol>
                  <CRow className="mb-3 align-items-center">
                    <CCol sm={1}>
                      <strong>ID</strong>: {deposit.transactionId}
                    </CCol>
                    <CCol sm={3}>
                      <strong>Created at</strong>: {deposit.createdAt}
                    </CCol>
                    <CCol sm={3}>
                      <strong>Updated at</strong>: {deposit.updatedAt}
                    </CCol>
                    <CCol sm={2}>
                      <strong>Processing type</strong>:{' '}
                      <Tag color={deposit.isAuto ? '#2eb85c' : '#321fdb'}>
                        {deposit.isAuto ? 'Auto' : 'Manual'}
                      </Tag>
                    </CCol>
                    <CCol sm={2} className="d-flex align-items-center gap-2">
                      <strong>Is Card:</strong>
                      {deposit.isCard ? (
                        <CheckCircleOutlined className={'text-success'} />
                      ) : (
                        <CloseSquareOutlined className={'text-danger'} />
                      )}
                    </CCol>
                  </CRow>
                  <Divider />

                  <CForm>
                    {loading ? (
                      <div className="mb-3">
                        <CSpinner />
                      </div>
                    ) : (
                      <CRow className="mb-3">
                        <CCol sm={4}>
                          <CInputGroup>
                            <CFormLabel
                              htmlFor="initialAmount"
                              className="col-12"
                            >
                              Initial amount
                            </CFormLabel>
                            <CFormInput
                              type="text"
                              id="initialAmount"
                              name="initialAmount"
                              value={deposit.initialAmount}
                              onChange={handleChange}
                              disabled={true}
                            />
                            <CInputGroupText>
                              {deposit.initialCurrency}
                            </CInputGroupText>
                          </CInputGroup>
                          <CFormInput
                            type="text"
                            id="initialCurrency"
                            name="initialCurrency"
                            value={deposit.initialCurrency}
                            onChange={handleChange}
                            disabled={true}
                          />
                        </CCol>
                        <CCol sm={4}>
                          <CInputGroup>
                            <CFormLabel
                              htmlFor="clientAmount"
                              className="col-12"
                            >
                              Client amount
                            </CFormLabel>
                            <CFormInput
                              type="text"
                              id="clientAmount"
                              name="clientAmount"
                              value={deposit.clientAmount}
                              onChange={handleChange}
                              disabled={true}
                            />
                            <CInputGroupText>
                              {deposit.clientCurrency}
                            </CInputGroupText>
                          </CInputGroup>
                          <CFormInput
                            type="text"
                            id="clientCurrency"
                            name="clientCurrency"
                            value={deposit.clientCurrency}
                            onChange={handleChange}
                            disabled={true}
                          />
                        </CCol>
                        <CCol sm={4}>
                          <CInputGroup>
                            <CFormLabel
                              htmlFor="companyAmount"
                              className="col-12"
                            >
                              Company amount
                            </CFormLabel>
                            <CFormInput
                              type="text"
                              id="companyAmount"
                              name="companyAmount"
                              value={deposit.companyAmount}
                              onChange={handleChange}
                              disabled={true}
                            />
                            <CInputGroupText>
                              {deposit.companyCurrency}
                            </CInputGroupText>
                          </CInputGroup>
                          <CFormInput
                            type="text"
                            id="companyCurrency"
                            name="companyCurrency"
                            value={deposit.companyCurrency}
                            onChange={handleChange}
                            disabled={true}
                          />
                        </CCol>
                      </CRow>
                    )}
                    <ChangeAmountsModal disabled={loading} />
                    {error.message.length > 0 && (
                      <CAlert color="danger">
                        Error code: {error.message}
                      </CAlert>
                    )}
                    {success.message.length > 0 && (
                      <CAlert color="success">{success.message}</CAlert>
                    )}
                    <Divider />
                    <CRow className="mb-3">
                      <CCol sm={3}>
                        <CFormInput
                          type="text"
                          id="commissionCurrency"
                          name="commissionCurrency"
                          value={deposit.commissionCurrency}
                          onChange={handleChange}
                          label="Commission currency"
                          disabled={true}
                        />
                      </CCol>
                      <CCol sm={3}>
                        <CFormInput
                          type="text"
                          id="clientCommission"
                          name="clientCommission"
                          value={deposit.clientCommission}
                          onChange={handleChange}
                          label="Client commission"
                          disabled={true}
                        />
                      </CCol>
                      <CCol sm={3}>
                        <CFormInput
                          type="text"
                          id="companyCommission"
                          name="companyCommission"
                          value={deposit.companyCommission}
                          onChange={handleChange}
                          label="Company commission"
                          disabled={true}
                        />
                      </CCol>
                      <CCol sm={3}>
                        <CFormInput
                          type="text"
                          id="innerCommission"
                          name="innerCommission"
                          value={deposit.innerCommission ?? 0}
                          onChange={handleChange}
                          label={'Inner commission ' + deposit.initialCurrency}
                          disabled={true}
                        />
                      </CCol>
                      <CCol sm={3} className="mt-2">
                        <CFormInput
                          type="text"
                          id="estimatedCommission"
                          name="estimatedCommission"
                          value={deposit.estimatedCommission ?? 0}
                          onChange={handleChange}
                          label={
                            'Estimated commission ' +
                            deposit.estimatedCommission
                          }
                          disabled={true}
                        />
                      </CCol>
                    </CRow>
                    <Divider />
                    <CRow className="mb-3">
                      <CCol sm={3}>
                        <CFormInput
                          type="text"
                          id="exchangeRate"
                          name="exchangeRate"
                          value={deposit.exchangeRate}
                          onChange={handleChange}
                          label="Exchange rate"
                          disabled={
                            userRole != undefined &&
                            (userRole.indexOf(
                              role.clientSupport.supportAgent(),
                            ) >= 0 ||
                              userRole.indexOf(
                                role.clientSupport.supportManager(),
                              ) >= 0)
                          }
                        />
                      </CCol>
                    </CRow>
                    <Divider />
                    <CRow className="mb-3">
                      <CCol sm={4}>
                        <p>mask: {deposit.clientPurse?.mask}</p>
                        <p>expiry: {deposit.clientPurse?.expiry}</p>
                        <p>type: {deposit.clientPurse?.type}</p>
                        <p>
                          verified:{' '}
                          {deposit.clientPurse?.verified ? 'yes' : 'no'}
                        </p>
                        <CFormSelect
                          id="clientPurseId"
                          name="clientPurseId"
                          label="Client purse ID"
                          value={deposit.clientPurseId}
                          onChange={handleChange}
                          disabled={
                            userRole != undefined &&
                            (userRole.indexOf(
                              role.clientSupport.supportAgent(),
                            ) >= 0 ||
                              userRole.indexOf(
                                role.clientSupport.supportManager(),
                              ) >= 0)
                          }
                          options={[
                            ...clientPurses.map((item) => {
                              return {
                                value: item.id?.toString(),
                                label:
                                  item.mask +
                                  ' is card: ' +
                                  item.isCard +
                                  ' verified: ' +
                                  item.verified,
                              }
                            }),
                          ]}
                        ></CFormSelect>
                      </CCol>
                      <CCol sm={4}>
                        <CFormInput
                          type="text"
                          id="processingProvider"
                          name="processingProvider"
                          value={deposit.processingProvider}
                          onChange={handleChange}
                          label="Processing provider"
                          className="mb-3"
                          disabled={true}
                        />
                      </CCol>
                      <CCol sm={4}>
                        <CFormInput
                          type="text"
                          id="providerId"
                          name="providerId"
                          value={deposit.providerId}
                          onChange={handleChange}
                          label="provider ID"
                          className="mb-3"
                          disabled={true}
                        />
                      </CCol>
                    </CRow>
                    <Divider />
                    <CRow>
                      <CCol>
                        <Typography.Text>
                          External ID: {deposit.externalTransaction?.externalId}
                          {deposit.externalPaymentTransaction?.externalId}
                        </Typography.Text>
                        {deposit.externalPaymentTransaction && (
                          <>
                            <Typography.Title level={4}>
                              vendor data
                            </Typography.Title>
                            <Space direction="vertical">
                              <Typography.Text>{`Status: ${deposit.externalPaymentTransaction?.externalStatus}`}</Typography.Text>
                              <Typography.Text>{`Initial amount: ${deposit.externalPaymentTransaction?.initialAmount}`}</Typography.Text>
                              <Typography.Text>{`Initial currency: ${deposit.externalPaymentTransaction?.initialCurrency}`}</Typography.Text>
                              <Typography.Text>{`Paid amount: ${deposit.externalPaymentTransaction?.paidAmount}`}</Typography.Text>
                              <Typography.Text>{`Paid currency: ${deposit.externalPaymentTransaction?.paidCurrency}`}</Typography.Text>
                              <Typography.Text>{`Commission: ${deposit.externalPaymentTransaction?.vendorCommission}`}</Typography.Text>
                              <Typography.Text>{`Commission currency: ${deposit.externalPaymentTransaction?.vendorCommissionCurrency}`}</Typography.Text>
                            </Space>
                          </>
                        )}
                      </CCol>
                    </CRow>
                    {(deposit?.order || deposit?.hotBuyOrder) && (
                      <>
                        <Divider />
                        <CRow className="mb-3">
                          <CCol sm={12}>
                            <Typography.Title level={4}>
                              Composition
                            </Typography.Title>

                            {deposit?.order && (
                              <div>
                                <Typography.Title level={5}>
                                  {`Order ID: ${deposit.order.orderId}`}
                                </Typography.Title>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '12px',
                                  }}
                                >
                                  {deposit.order.orderItems.map(
                                    (item, index) => (
                                      <div key={item.PropertyID + index}>
                                        <Typography.Title
                                          level={5}
                                        >{`Property №${
                                          index + 1
                                        }`}</Typography.Title>
                                        <Space direction="vertical">
                                          <Typography.Text>{`Property ID: ${item.PropertyID}`}</Typography.Text>
                                          <Typography.Text>{`Property name: ${item.PropertyName}`}</Typography.Text>
                                          <Typography.Text>{`Number of tokens: ${item.Amount}`}</Typography.Text>
                                          <Typography.Text>{`Token price: ${item.TokenPrice}`}</Typography.Text>
                                          <Typography.Text>{`Total order amount: ${item.Price}`}</Typography.Text>
                                        </Space>
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            )}

                            <div style={{ marginTop: 16 }} />

                            {deposit?.hotBuyOrder && (
                              <div>
                                <Typography.Title level={5}>
                                  {`Hot buy order ID: ${deposit.hotBuyOrder.id}`}
                                </Typography.Title>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '12px',
                                  }}
                                >
                                  {deposit.hotBuyOrder.items.map(
                                    (item, index) => (
                                      <div key={item.PropertyID + index}>
                                        <Typography.Title
                                          level={5}
                                        >{`Property №${
                                          index + 1
                                        }`}</Typography.Title>
                                        <Space direction="vertical">
                                          <Typography.Text>{`Property ID: ${item.PropertyID}`}</Typography.Text>
                                          <Typography.Text>{`Property name: ${item.PropertyName}`}</Typography.Text>
                                          <Typography.Text>{`Number of tokens: ${item.TokenAmount}`}</Typography.Text>
                                          <Typography.Text>{`Token price: ${item.TokenPriceTaker}`}</Typography.Text>
                                          <Typography.Text>{`Total order amount: ${item.TotalPriceTaker}`}</Typography.Text>
                                        </Space>
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            )}
                          </CCol>
                        </CRow>
                      </>
                    )}
                    <Divider />
                    <Guard permission="edit_tranasaction_data">
                      <CButton
                        className="mb-3"
                        disabled={
                          loading ||
                          deposit.status ==
                            transactionRequestStatus.rejected() ||
                          (userRole != undefined &&
                            (userRole.indexOf(
                              role.clientSupport.supportAgent(),
                            ) >= 0 ||
                              userRole.indexOf(
                                role.clientSupport.supportManager(),
                              ) >= 0))
                        }
                        onClick={() => submitEditDeposit(deposit)}
                      >
                        {loading && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                        Save
                      </CButton>
                    </Guard>
                  </CForm>
                </CCol>
              </CRow>
            </CTabPane>
            <CTabPane
              data-tab="history"
              role="tabpanel"
              aria-labelledby="contact-tab"
              visible={activeClientTab === 2}
            >
              <CCol xs={12}>
                <CCard className="mb-4">
                  <CCardBody className="bg-dark">
                    {deposit?.clientId != '' && (
                      <TransactionList entityId={deposit.clientId} />
                    )}
                  </CCardBody>
                </CCard>
              </CCol>
            </CTabPane>
            <CTabPane
              data-tab="moneyHistory"
              role="tabpanel"
              aria-labelledby="contact-tab"
              visible={activeClientTab === 3}
            >
              <CRow>
                <CCol xs={12}>
                  <CCard className="mb-4">
                    <CCardHeader>
                      <strong>Money History</strong>
                    </CCardHeader>
                    <CCardBody>
                      {deposit?.clientId != '' && (
                        <MoneyHistoryList
                          entityId={deposit.clientId}
                          client={{
                            name: deposit.client?.fullName,
                            email: deposit.client?.email,
                            country: deposit.client?.country,
                          }}
                        />
                      )}
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CTabPane>
            <CTabPane
              data-tab="actionHistory"
              role="tabpanel"
              aria-labelledby="contact-tab"
              visible={activeClientTab === 4}
            >
              <ActionHistory
                history={deposit.changeHistoryAll}
                createdAt={deposit.createdAt}
                acceptedAt={deposit.confirmedByVendorAt}
              />
            </CTabPane>
          </CTabContent>
        </CCardBody>
      </CCard> */}

      {isOpenModal && (
        <TransactionHelpModal
          transactionId={Number(deposit.transactionId)}
          isVisible={isOpenModal}
          onClose={() => setIsOpenModal(false)}
        />
      )}
      <AdjustmentDepositModal
        open={isOpenAdjustmentDepositModal}
        setOpen={setIOpenAdjustmentDepositModal}
        transactionId={deposit.transactionId}
      />
    </div>
  )
}
